import { action } from 'typesafe-actions';
import { TurnstilesTypes, TurnstilesInteface } from './types';

// List Turnstiles
export const listTurnstilesRequest = (payload: { body?: object }) =>
  action(TurnstilesTypes.LIST_TURNSTILES_REQUEST, payload);
export const listTurnstilesSuccess = (payload: {
  turnstilesList: TurnstilesInteface[];
}) => action(TurnstilesTypes.LIST_TURNSTILES_SUCCESS, payload);
export const listTurnstilesFailure = () =>
  action(TurnstilesTypes.LIST_TURNSTILES_FAILURE);
